import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  query,
  setDoc,
} from "firebase/firestore/lite";
import { EPostStatus, EPostType, TPost } from "../models/posts.model";
import { TResponse } from "./apiWorker";

export async function getPublicTimelines({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: TResponse<{ name: string; id: string }>) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();
  const queried = query(collection(db, "ptimelines"));

  const { docs } = await getDocs(queried);

  const posts = docs.map((doc) => {
    const data = doc.data();
    return {
      ...data,
      id: doc.id,
    } as { name: string; id: string };
  });

  onSuccess?.({
    content: posts,
    total: posts.length,
    limit: 0,
    offset: 0,
  });
}

export async function followPublicTimeline({
  timelineId,
  onSuccess,
  onError,
}: {
  timelineId: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();
  const followersRef = collection(db, "ptimelines", timelineId, "followers");

  await setDoc(doc(followersRef, localStorage.getItem("uid") || ""), {
    createdAt: new Date().toISOString(),
  });

  onSuccess?.({});
}

export async function unfollowPublicTimeline({
  timelineId,
  onSuccess,
  onError,
}: {
  timelineId: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();
  const followersRef = collection(db, "ptimelines", timelineId, "followers");

  try {
    await deleteDoc(doc(followersRef, localStorage.getItem("uid") || ""));
    onSuccess?.({});
  } catch (error) {
    onError?.(error);
  }
}

export async function getFollowingPublicTimelines({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: TResponse<string>) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();

  const ptimelinesRef = collection(db, "ptimelines");
  const ptimelinesSnapshot = await getDocs(ptimelinesRef);

  const followed = (
    await Promise.all(
      ptimelinesSnapshot.docs.map(async (_doc) => {
        const followerDoc = await getDoc(
          doc(
            collection(db, "ptimelines", _doc.id, "followers"),
            localStorage.getItem("uid") || ""
          )
        );
        return followerDoc.exists() ? _doc.id : null;
      })
    )
  ).filter((doc) => doc !== null) as string[];

  onSuccess?.({
    content: followed,
    total: followed.length,
    limit: 0,
    offset: 0,
  });
}

export async function getEventsFromPublicTimeline({
  timelineId,
  onSuccess,
  onError,
}: {
  timelineId: string;
  onSuccess?: (data: TResponse<TPost>) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();
  const queried = query(collection(db, "ptimelines", timelineId, "events"));

  const { docs } = await getDocs(queried);

  const posts = docs.map((doc) => {
    const data = doc.data();

    //   {
    //     "title": "Apollo-Soyuz Test Project",
    //     "dateStart": "15-07-1975",
    //     "dateEnd": "24-07-1975",
    //     "description": "First international crewed mission between the United States and the Soviet Union.",
    //     "city": "Low Earth Orbit",
    //     "state": "-",
    //     "country": "Space",
    //     "latitude": 0,
    //     "longitude": 0,
    //     "photo": "https://www.nasa.gov/apollo-soyuz-test-project/",
    //     "source": "https://en.wikipedia.org/wiki/Apollo%E2%80%93Soyuz_Test_Project",
    //     "id": "apollo-soyuz_test_project",
    //     "batchId": "history_-_man_in_space"
    // }

    const eventDate = new Date();
    const dateParts = data.dateStart.split("-");

    if (dateParts.length == 3) {
      eventDate.setFullYear(parseInt(dateParts[2]));
      eventDate.setMonth(parseInt(dateParts[1]) - 1);
      eventDate.setDate(parseInt(dateParts[0]));
    } else if (dateParts.length == 2) {
      eventDate.setFullYear(parseInt(dateParts[1]));
      eventDate.setMonth(parseInt(dateParts[0]) - 1);
    } else {
      eventDate.setFullYear(parseInt(data.dateStart));
    }

    return {
      ...data,
      title: data.title,
      eventDate: isNaN(eventDate.getTime())
        ? undefined
        : eventDate.toISOString(),
      content: {
        text: data.description,
      },
      metadata: {
        location: {
          city: data.city,
          state: data.state,
          country: data.country,
          latitude: data.latitude,
          longitude: data.longitude,
        },
        batchId: data.batchId,
        source: data.source,
      },
      medias: [data.photo || data.audio || data.video],
      type: EPostType.EVENT,
      status: EPostStatus.PUBLISH,
      id: doc.id,
    } as TPost;
  });

  onSuccess?.({
    content: posts,
    total: posts.length,
    limit: 0,
    offset: 0,
  });
}
